var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLanedeparturewarning = function SvgLanedeparturewarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9183 3.11932L13.903 2.26727C13.486 2.08805 13.0406 2 12.5857 2C11.2085 2 9.91337 2.85837 9.37004 4.13804L8.03069 7.28533L6.34386 7.57146L6.45127 8.19085L7.73692 7.9739L4.02528 16.6801L4 16.7398L4.01895 18.1012C4.03474 19.0948 4.63809 19.9877 5.55415 20.3745L8.64035 21.6761C8.95307 21.8082 9.28474 21.8742 9.62591 21.8742C10.2672 21.8742 10.88 21.6353 11.3506 21.1951L11.7897 20.7832V22H12.4215V20.0883L16.0826 11.4985L16.8186 12.5707L17.3398 12.2154L16.3764 10.8099L17.7157 7.66263C17.9052 7.22874 18 6.76656 18 6.28864C18 4.89578 17.185 3.65383 15.9183 3.11932ZM11.6106 19.2699C7.65645 19.2242 5.39865 16.674 5.21456 16.5864L7.36005 14.051C7.61295 14.402 7.58841 14.3698 7.61665 14.4062C9.10457 16.326 11.8968 16.0224 11.9496 16.0322L11.6106 19.2699ZM13.6213 12.0675L13.3702 11.8756C12.1067 10.9103 10.4678 10.2786 9.36672 10.1787L9.03479 10.1472L9.50399 7.04695L9.65546 6.97525C10.8212 6.41718 14.0671 7.43831 15.2222 9.00082C15.4062 9.2497 15.4645 9.41602 15.4703 9.43347L15.5228 9.59129L13.6213 12.0675ZM16.0083 7.04142L15.5434 5.29463L12.4919 4.0055L10.9067 4.88672L10.5988 4.33772L12.4537 3.30635L16.0753 4.83591L16.6191 6.88053L16.0083 7.04142Z",
    fill: "#696593"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.72426V5.73393H3.56595V5.72426V3.38281H3V5.72426Z",
    fill: "#696593"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.17967V9.50551V9.53079H3.56595V9.50551V7.17967V7.16406H3V7.17967Z",
    fill: "#696593"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.9806V13.2908V13.3317H3.56595V13.2908V10.9806V10.9492H3V10.9806Z",
    fill: "#696593"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.7773V17.0721V17.1286H3.56595V17.0721V14.7773V14.7305H3V14.7773Z",
    fill: "#696593"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5742V20.8533V20.9254H3.56595V20.8533V18.5742V18.5117H3V18.5742Z",
    fill: "#696593"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1089 3.38281H20.543V5.72426H21.1089V3.38281Z",
    fill: "#696593"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1089 7.16406H20.543V9.50551H21.1089V7.16406Z",
    fill: "#696593"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1089 10.9492H20.543V13.2908H21.1089V10.9492Z",
    fill: "#696593"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1089 14.7305H20.543V17.0721H21.1089V14.7305Z",
    fill: "#696593"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1089 18.5117H20.543V20.8533H21.1089V18.5117Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLanedeparturewarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lanedeparturewarning.f629201c97c26c1942bb237a47702897.svg";